import * as moment from "moment";

class IndividualFeesAuditingController implements angular.IOnInit {
  public searchText: string = "";

  // Bindings from parent
  public isIndividualClientDaily: boolean;
  public selectedClients: Array<any>;
  public clientsForUser: Array<any>;
  public individualsFromDate: Date;
  public individualsToDate: Date;
  public currentDate: Date;
  public isLoadingClients: boolean;

  /** @ngInject */
  constructor() {}

  $onInit() {}

  formatDate(selectedDate) {
    return moment(selectedDate).endOf("month").format("YYYY-MM");
  }

  clearSearchTerm() {
    this.searchText = '';
  }

  // Custom filter function to search by client name, client number, and portfolio account numbers
  filterClients = (client: any) => {
    if (!this.searchText) return true;
    
    const searchLower = this.searchText.toLowerCase().trim();
    
    // Search by client name
    if (client.name && client.name.toLowerCase().includes(searchLower)) {
      return true;
    }
    
    // Search by client number
    if (client.clientNumber && client.clientNumber.toLowerCase().includes(searchLower)) {
      return true;
    }
    
    // Search by portfolio account numbers
    if (client.portfolioAccountNumbers && client.portfolioAccountNumbers.length > 0) {
      const matchesPortfolio = client.portfolioAccountNumbers.some((accountNumber: string) => 
        accountNumber && accountNumber.toLowerCase().includes(searchLower)
      );
      if (matchesPortfolio) {
        return true;
      }
    }
    
    return false;
  };
}

export const individualFeesAuditing: angular.IComponentOptions = {
  template: require("./individual-fees-auditing.html"),
  controller: IndividualFeesAuditingController,
  bindings: {
    isIndividualClientDaily: "=",
    selectedClients: "=",
    clientsForUser: "<",
    individualsFromDate: "=",
    individualsToDate: "=",
    currentDate: "<",
    isLoadingClients: "<",
  },
};




// WEBPACK FOOTER //
// ./src/app/fees/fees-components/individual-fees-auditing/individual-fees-auditing.ts